import React from 'react';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Testimonials from '../../components/testimonials';
import ArtikelSektion from '../../components/artikelsektion';
import SEO from '../../components/SEO';
import CTAKnap, { CTAIkoner } from '../../components/ctaknap';
import Prisudregner from '../../components/prisudregner';
import './styles/priserside.css';

const PriserSide = () => {
  // Scroll til prisudregner funktion
  const scrollToPrisudregner = (e) => {
    e.preventDefault();
    const element = document.getElementById('prisudregner');
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <div className="priser-side">
      <SEO 
        title="Priser på Hjemmeside - Se hvad en Investering Koster | Parla Branding"
        description="Få et klart overblik over priserne på en professionel hjemmeside. Vi tror på fuld transparens uden skjulte gebyrer. Se vores pakker og beregn et estimat."
        keywords="hjemmeside investering pris, transparent priser hjemmeside, hjemmeside pakker, estimat hjemmeside, professionel hjemmeside pris, ingen skjulte gebyrer"
        url="https://parlabranding.dk/priser"
        type="website"
        canonicalUrl="https://www.parlabranding.dk/priser"
      />
      <Header />
      
      {/* Hero sektion */}
      <section className="priser-hero">
        <div className="container">
          <div className="priser-hero-content">
            <div className="priser-hero-left">
              <span className="priser-hero-badge">
                Transparente Priser
              </span>
              <h1 className="priser-hero-title">
                Investér i <span className="priser-hero-accent">Hjemmesider</span> der skaber vækst
              </h1>
              <p className="priser-hero-description">
                Vores transparente priser gør det nemt at vælge den rette løsning. Vi leverer hjemmesider der arbejder for din forretning og bringer dig nye kunder. SEO-optimering tilbydes som tillæg for maksimal synlighed.
              </p>
              <div className="priser-hero-features">
                <div className="priser-hero-feature">
                  <div className="feature-icon">✓</div>
                  <span>Klare priser uden overraskelser</span>
                </div>
                <div className="priser-hero-feature">
                  <div className="feature-icon">✓</div>
                  <span>30 dages pengene tilbage garanti</span>
                </div>
                <div className="priser-hero-feature">
                  <div className="feature-icon">✓</div>
                  <span>Gratis konsultation og skræddersyet tilbud</span>
                </div>
              </div>
              <div className="priser-hero-actions">
                <CTAKnap 
                  variant="primary" 
                  size="large"
                  href="/kontakt"
                  icon={<CTAIkoner.ArrowRight />}
                >
                  Få et gratis tilbud
                </CTAKnap>
                <CTAKnap 
                  variant="outline" 
                  size="large"
                  href="/tjenester"
                  icon={<CTAIkoner.BarChart />}
                >
                  Se vores tjenester
                </CTAKnap>
              </div>
            </div>
            <div className="priser-hero-visual">
              <div className="priser-pricing-preview">
                <div className="pricing-card-mini featured">
                  <div className="popular-badge">Mest Populær</div>
                  <div className="card-header">
                    <h4>Mellem Hjemmeside</h4>
                    <div className="price">
                      <span>Fra 20.000 kr</span>
                      <small className="price-tax-note">(ekskl. moms)</small>
                    </div>
                  </div>
                  <div className="card-features">
                    <div className="feature">• Op til 15 undersider</div>
                    <div className="feature">• Responsive design</div>
                    <div className="feature">• Kontaktformularer</div>
                    <div className="feature">• SEO optimeret</div>
                  </div>
                </div>
                <div className="pricing-card-mini">
                  <div className="card-header">
                    <h4>Basis SEO</h4>
                    <div className="price">
                      <span>Fra 5.000 kr/md</span>
                      <small className="price-tax-note">(ekskl. moms)</small>
                    </div>
                  </div>
                  <div className="card-features">
                    <div className="feature">• Keyword research</div>
                    <div className="feature">• On-page optimering</div>
                    <div className="feature">• Teknisk SEO audit</div>
                    <div className="feature">• Månedlig rapportering</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <Testimonials />

      {/* Hjemmeside Priser */}
      <section className="hjemmeside-priser">
        <div className="container">
          <div className="priser-header">
            <span className="priser-badge">Hjemmeside Priser</span>
            <h2 className="priser-title">
              <span className="priser-accent">Hjemmeside</span> Pakker
            </h2>
            <p className="priser-description">
              Fra simple landingpages til komplekse webshops. Alle vores hjemmesider er mobilvenlige, SEO-forberedte og bygget med moderne teknologi. Vi sørger for at din hjemmeside laver kunder til dig døgnet rundt.
            </p>
          </div>
          
          <div className="pricing-grid">
            <div className="pricing-card">
              <div className="pricing-card-header">
                <h3 className="pricing-card-title">Lille</h3>
                <div className="pricing-card-price">
                  <span className="price-amount">Fra 10.000 kr</span>
                  <span className="price-tax-note">(ekskl. moms)</span>
                  <span className="price-period">Engangsbeløb</span>
                </div>
                <p className="pricing-card-description">
                  Perfekt til små virksomheder der ønsker en professionel online tilstedeværelse.
                </p>
              </div>
              <div className="pricing-card-features">
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Op til 5 undersider</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Responsive design</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Grundlæggende SEO</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Kontaktformular</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Google Analytics</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">1 måned support</div>
                </div>
              </div>
              <div className="pricing-card-cta">
                <CTAKnap 
                  variant="outline"
                  size="large"
                  onClick={scrollToPrisudregner}
                  icon={<CTAIkoner.ArrowRight />}
                >
                  Få din pris
                </CTAKnap>
              </div>
            </div>

            <div className="pricing-card pricing-card--popular">
              <div className="pricing-card-badge">Mest Populær</div>
              <div className="pricing-card-header">
                <h3 className="pricing-card-title">Mellem</h3>
                <div className="pricing-card-price">
                  <span className="price-amount">Fra 20.000 kr</span>
                  <span className="price-tax-note">(ekskl. moms)</span>
                  <span className="price-period">Engangsbeløb</span>
                </div>
                <p className="pricing-card-description">
                  Ideel til etablerede virksomheder der ønsker en professionel hjemmeside med avancerede funktioner.
                </p>
              </div>
              <div className="pricing-card-features">
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Op til 15 undersider</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Professionelt design</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Kontaktformularer & integration</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Avanceret SEO setup</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Blog funktionalitet</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Social media integration</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">3 måneders support</div>
                </div>
              </div>
              <div className="pricing-card-cta">
                <CTAKnap 
                  variant="primary"
                  size="large"
                  onClick={scrollToPrisudregner}
                  icon={<CTAIkoner.ArrowRight />}
                >
                  Få din pris
                </CTAKnap>
              </div>
            </div>

            <div className="pricing-card">
              <div className="pricing-card-header">
                <h3 className="pricing-card-title">Stor</h3>
                <div className="pricing-card-price">
                  <span className="price-amount">Fra 50.000 kr</span>
                  <span className="price-tax-note">(ekskl. moms)</span>
                  <span className="price-period">Engangsbeløb</span>
                </div>
                <p className="pricing-card-description">
                  For store virksomheder med komplekse behov og integration til eksisterende systemer.
                </p>
              </div>
              <div className="pricing-card-features">
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">+25 undersider</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Skræddersyet design</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Avancerede funktioner</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">E-commerce muligheder</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">API integrationer</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Dedikeret projektleder</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">6 måneders support</div>
                </div>
              </div>
              <div className="pricing-card-cta">
                <CTAKnap 
                  variant="outline"
                  size="large"
                  onClick={scrollToPrisudregner}
                  icon={<CTAIkoner.ArrowRight />}
                >
                  Få din pris
                </CTAKnap>
              </div>
            </div>
          </div>

          <div className="priser-note">
            <p>
              Alle priser er ekskl. moms og hosting. Vi tilbyder forskellige hosting løsninger fra 200 kr/måned.
              Kontakt os for et skræddersyet tilbud der passer til jeres specifikke behov.
            </p>
          </div>
        </div>
      </section>

      {/* SEO Priser */}
      <section className="seo-priser">
        <div className="container">
          <div className="priser-header">
            <span className="priser-badge seo-badge">SEO Tillæg</span>
            <h2 className="priser-title">
              <span className="priser-accent">SEO Optimering</span> som Tillæg
            </h2>
            <p className="priser-description">
              En hjemmeside skal kunne findes på Google for at være effektiv. Vores SEO-tjenester hjælper din virksomhed med bedre synlighed og flere relevante besøgende. Alle pakker inkluderer månedlig rapportering.
            </p>
          </div>
          
          <div className="pricing-grid">
            <div className="pricing-card seo-pricing-card">
              <div className="pricing-card-header">
                <h3 className="pricing-card-title">Basis SEO</h3>
                <div className="pricing-card-price">
                  <span className="price-amount">5.000 kr</span>
                  <span className="price-tax-note">(ekskl. moms)</span>
                  <span className="price-period">pr. måned</span>
                </div>
                <p className="pricing-card-description">
                  Grundlæggende SEO for små virksomheder der vil forbedre deres synlighed på Google.
                </p>
              </div>
              <div className="pricing-card-features">
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Keyword research (10 keywords)</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">On-page optimering</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Teknisk SEO audit</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Google My Business optimering</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Månedlig progress rapport</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Email support</div>
                </div>
              </div>
              <div className="pricing-card-cta">
                <CTAKnap 
                  variant="outline"
                  size="large"
                  onClick={scrollToPrisudregner}
                  icon={<CTAIkoner.Search />}
                >
                  Få SEO pris
                </CTAKnap>
              </div>
            </div>

            <div className="pricing-card seo-pricing-card pricing-card--popular">
              <div className="pricing-card-badge seo-badge">Mest Populær</div>
              <div className="pricing-card-header">
                <h3 className="pricing-card-title">Standard SEO</h3>
                <div className="pricing-card-price">
                  <span className="price-amount">12.000 kr</span>
                  <span className="price-tax-note">(ekskl. moms)</span>
                  <span className="price-period">pr. måned</span>
                </div>
                <p className="pricing-card-description">
                  Omfattende SEO strategi med content marketing og link building for vækstorienterede virksomheder.
                </p>
              </div>
              <div className="pricing-card-features">
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Keyword research (25 keywords)</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Avanceret on-page optimering</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Content marketing (2 artikler/måned)</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Link building kampagne</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Konkurrent analyse</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Detaljeret månedlig rapport</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Telefonisk support</div>
                </div>
              </div>
              <div className="pricing-card-cta">
                <CTAKnap 
                  variant="primary"
                  size="large"
                  onClick={scrollToPrisudregner}
                  icon={<CTAIkoner.Search />}
                >
                  Få SEO pris
                </CTAKnap>
              </div>
            </div>

            <div className="pricing-card seo-pricing-card">
              <div className="pricing-card-header">
                <h3 className="pricing-card-title">Premium SEO</h3>
                <div className="pricing-card-price">
                  <span className="price-amount">25.000 kr</span>
                  <span className="price-tax-note">(ekskl. moms)</span>
                  <span className="price-period">pr. måned</span>
                </div>
                <p className="pricing-card-description">
                  Komplet SEO løsning for store virksomheder med dedikeret SEO specialist.
                </p>
              </div>
              <div className="pricing-card-features">
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Ubegrænset keyword research</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Skræddersyet SEO strategi</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Ugentligt content (4+ artikler)</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Avanceret link building</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Dedikeret SEO specialist</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">Ugentlige status møder</div>
                </div>
                <div className="pricing-feature">
                  <div className="feature-check">✓</div>
                  <div className="feature-text">24/7 prioriteret support</div>
                </div>
              </div>
              <div className="pricing-card-cta">
                <CTAKnap 
                  variant="outline"
                  size="large"
                  onClick={scrollToPrisudregner}
                  icon={<CTAIkoner.Search />}
                >
                  Få SEO pris
                </CTAKnap>
              </div>
            </div>
          </div>

          <div className="priser-note seo-note">
            <p>
              Alle SEO pakker kræver minimum 6 måneders aftale for at opnå optimale resultater. 
              Vi tilbyder også engangstjenester som SEO audit, keyword research og teknisk optimering.
            </p>
          </div>
        </div>
      </section>

      {/* Prisudregner sektion */}
      <section id="prisudregner" className="priser-calculator-section">
        <div className="container">
          <div className="priser-calculator-header">
            <h2 className="priser-calculator-title">
              Få dit <span className="priser-calculator-accent">præcise tilbud</span>
            </h2>
            <p className="priser-calculator-description">
              Brug vores prisudregner til at få et skræddersyet tilbud på få minutter
            </p>
          </div>
          <div className="priser-calculator-wrapper">
            <Prisudregner />
          </div>
        </div>
      </section>
      
      {/* Artikler */}
      <ArtikelSektion />
      
      <Footer />
    </div>
  );
};

export default PriserSide;
